import React from 'react';
import ReactDOM from 'react-dom/client';
import '@britishcouncil/semantic-ui-admin/dist/semantic.min.css';
import { ToastContainer, ToastOptions } from '@britishcouncil/react-admin';
import { Providers } from 'Providers';

import App from './App';
import './index.scss';

//[GP]: this one is required for react-table package. Once we will migrate to @tanstack/react-table we can remove this
import 'regenerator-runtime';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const defaultToastOptions: ToastOptions = {
  icon: true,
  position: 'bottom right',
};

root.render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
    <ToastContainer defaultOptions={defaultToastOptions} />
  </React.StrictMode>
);
